import React from 'react';

import FullBlueContent from '../full-blue-content';
import ServiceItemWrapper from '../service-item-wrapper';

const blueContent1 = [
    'Этот раздел клиент самостоятельно администрирует через админпанель. Для удобства администрирования все элементы ' +
        'мы&nbsp;вынесли в&nbsp;отдельные инфоблоки. ',
    'Время на&nbsp;разработку и&nbsp;правки&nbsp;&mdash; 200&nbsp;часов.',
];

const blueContent2 = [
    'Раздел посвящен вопросам, связанным с&nbsp;коронавирусом. Наполнение раздела новыми данными занимает не&nbsp;более ' +
        '15&nbsp;минут. Это позволяет максимально оперативно сообщать экспортерам об&nbsp;обстановке в&nbsp;мире и&nbsp;на&nbsp;границей ' +
        'в&nbsp;связи с&nbsp;коронавирусной инфекцией. Здесь&nbsp;же размещены актуальные рекомендации компаниям по&nbsp;ведению бизнеса ' +
        'в&nbsp;кризисный период и&nbsp;антикризисные кейсы. ',
    'Этот раздел был создан в&nbsp;очень сжатые срок: разработка и&nbsp;доработка раздела заняла 50&nbsp;часов.',
];

const blueContent3 = [
    'Сервисы этой системы, объединенные в&nbsp;платформу &laquo;Мой экспорт&raquo;, помогают решить основные задачи ' +
        'бизнеса на&nbsp;каждом этапе экспортного цикла: от&nbsp;получения необходимых компетенций и&nbsp;поиска контрагентов ' +
        'до&nbsp;оформления экспортной сделки с&nbsp;использованием государственных сервисов и&nbsp;услуг группы РЭЦ.',
    'Экспортеры имеют доступ к&nbsp;платформе 24/7',
];

const blueContent4 = [
    'Данная автоматизация освободила около 50&nbsp;рабочих часов сотрудника, ответственного за&nbsp;конкурс, ежемесячно',
    'Автоматизация помогла эффективнее распределять ресурсы',
];

const serviceItem2 = {
    img: '/images/pic/dev-rec/service-2.png',
    title: 'Оперативный штаб',
    link: 'https://www.exportcenter.ru/operativnyi-shtab-rec/',
    text: [
        'Здесь любой экспортер может получить рекомендацию по&nbsp;выбору маркетплейса для экспорта своего продукта, ' +
            'настроив фильтры по&nbsp;стране поставки и&nbsp;отрасли. Кроме того, зарегистрированные пользователи могут',
    ],
    isReversed: false,
};

const serviceItem3 = {
    img: '/images/pic/dev-rec/service-3.png',
    title: 'Промо-лендинг для цифровой платформы &laquo;Мой экспорт&raquo;&nbsp;&mdash; ИС&nbsp;&laquo;Одно окно&raquo;',
    link: 'https://www.exportcenter.ru/single-window/',
    text: [
        'Лендинг предоставляет для пользователей информацию о&nbsp;новом сервисе, его возможностях и&nbsp;преимуществах.',
        '&laquo;Одно окно&raquo;&nbsp;&mdash; цифровая экосистема, которая призвана обеспечить бизнесу онлайн-доступ ' +
            'из&nbsp;одной точки к&nbsp;государственным и&nbsp;иным услугам, сопровождающим выход компаний на&nbsp;экспорт.',
    ],
    isReversed: true,
};

const serviceItem4 = {
    img: '/images/pic/dev-rec/service-4.png',
    title: 'Опросник для конкурса',
    text: [
        'Раз в&nbsp;год группа РЭЦ проводит конкурс &laquo;Экспортер года&raquo;. Ежегодно количество заявок ' +
            'увеличивается: в&nbsp;прошлом году их&nbsp;было 1724. Анкеты для участия объемные, с&nbsp;загрузкой ' +
            'документов, и&nbsp;раньше их&nbsp;проверяли вручную. ',
        'Для автоматизации сбора заявок мы&nbsp;разработали и&nbsp;интегрировали функционал сложного опроса ' +
            'с&nbsp;автоподсчетом результатов. При выгрузке результатов реализовано более 10&nbsp;условий формирования ' +
            'собранных отчётов.',
    ],
    isReversed: false,
};

const Services = () => {
    return (
        <>
            <FullBlueContent text={blueContent1} />
            <ServiceItemWrapper item={serviceItem2} />
            <FullBlueContent text={blueContent2} />
            <ServiceItemWrapper item={serviceItem3} />
            <FullBlueContent text={blueContent3} />
            <ServiceItemWrapper item={serviceItem4} />
            <FullBlueContent text={blueContent4} />
        </>
    );
};

export default Services;
